<template>
  <div class="row dashboard">
    <div class="col-md-9">
      <!-- Welcome, Golf Aus -->
      <div class="col-12 mb-5">
        <div>
          <h4>Welcome, {{ displayName }}</h4>
          <div v-html="introduction" v-if="!isEditIntro"></div>
          <div class="mb-4" v-if="isNationalAssociationUser">
            <button type="button" class="btn btn-primary" v-if="!isEditIntro" @click="isEditIntro = true;">Edit
              Introduction</button>
            <div v-if="isEditIntro">
              <RichTextEditor v-model="introduction" />
              <div class="mt-2">
                <button type="button" class="btn btn-primary" @click="saveIntroduction" :disabled="isLoading">Update
                  Introduction</button>
                <button type="button" class="btn btn-light" @click="cancelIntroduction">Cancel</button>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion mb-4" id="dashboardItems">
          <div class="accordion-item" v-for="(item, index) in items" v-bind:key="index">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                :data-bs-target="`#collapse-${index}`" aria-expanded="false" :aria-controls="`collapse-${index}`">
                <strong>{{ item.title }}</strong>
              </button>
            </h2>
            <div :id="`collapse-${index}`" class="accordion-collapse collapse" data-bs-parent="#dashboardItems">
              <div class="accordion-body">
                <div class="mb-3" v-if="isNationalAssociationUser">
                  <template v-if="!isDeleteItemMode">
                    <button class="btn btn-primary btn-sm" @click="setForm(item, index)">Edit
                      Item</button>
                    <button class="btn btn-warning btn-sm" @click="isDeleteItemMode = true">Delete
                      Item</button>
                  </template>
                  <template v-if="isDeleteItemMode">
                    <button class="btn btn-danger btn-sm" @click="deleteItem(index)">Confirm
                      Delete</button>
                    <button class="btn btn-light btn-sm" @click="isDeleteItemMode = false">Cancel
                      Delete</button>
                  </template>
                </div>
                <div v-html="item.body"></div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary" v-if="isNationalAssociationUser && !isUpdateMode" @click="addItem">Add New
          Item</button>
  <div v-show="isUpdateMode" ref="itemFormRef">
          <h5>Add New Item</h5>
          <div class="mb-3">
            <label for="title" class="form-label">Title</label>
            <input type="text" class="form-control" id="title" v-model="title" ref="titleElement">
          </div>
          <div class="mb-3">
            <label for="body" class="form-label">Body</label>
            <RichTextEditor v-model="body" />
          </div>
          <button type="button" class="btn btn-primary" @click="saveItem" :disabled="!title || !body || isLoading">Save</button>
          <button type="button" class="btn btn-light" @click="clear(); isUpdateMode = false;">Cancel</button>
        </div>
      </div>

      <!-- Visible to Golf Aus Staff -->
      <div class="col-12" v-if="isNationalAssociationUser">
        <div>
          <div v-html="introduction2" v-if="!isEditIntro2"></div>
          <div class="mb-4">
            <button type="button" class="btn btn-primary" v-if="!isEditIntro2" @click="isEditIntro2 = true;">Edit
              Content</button>
            <div v-if="isEditIntro2">
              <RichTextEditor v-model="introduction2" />
              <div class="mt-2">
                <button type="button" class="btn btn-primary" @click="saveContent" :disabled="isLoading">Update
                  Content</button>
                <button type="button" class="btn btn-light" @click="cancelIntroduction">Cancel</button>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion mb-4" id="dashboardItems2">
          <div class="accordion-item" v-for="(item2, index) in items2" :key="`${index + 1000}`">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                :data-bs-target="`#collapse-${index + 1000}`" aria-expanded="false"
                :aria-controls="`collapse-${index + 1000}`">
                <strong>{{ item2.title }}</strong>
              </button>
            </h2>
            <div :id="`collapse-${index + 1000}`" class="accordion-collapse collapse" data-bs-parent="#dashboardItems2">
              <div class="accordion-body">
                <div class="mb-3" v-if="isNationalAssociationUser">
                  <template v-if="!isDeleteItems2Mode">
                    <button class="btn btn-primary btn-sm" @click="setItems2Form(item2, (index + 1000))">Edit
                      Item</button>
                    <button class="btn btn-warning btn-sm" @click="isDeleteItems2Mode = true">Delete
                      Item</button>
                  </template>
                  <template v-if="isDeleteItems2Mode">
                    <button class="btn btn-danger btn-sm" @click="deleteItems2(index + 1000)">Confirm
                      Delete</button>
                    <button class="btn btn-light btn-sm" @click="isDeleteItems2Mode = false">Cancel
                      Delete</button>
                  </template>
                </div>
                <div v-html="item2.body"></div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary" v-if="isNationalAssociationUser && !isItems2UpdateMode" @click="addItems2">Add
          New
          Item</button>
  <div v-show="isItems2UpdateMode" ref="item2FormRef">
          <h5>Add New Item</h5>
          <div class="mb-3">
            <label for="title2" class="form-label">Title</label>
            <input type="text" class="form-control" id="title2" v-model="title2" ref="title2Element">
          </div>
          <div class="mb-3">
            <label for="body2" class="form-label">Body</label>
            <RichTextEditor v-model="body2" />
          </div>
          <button type="button" class="btn btn-primary" @click="saveItems2" :disabled="!title2 || !body2 || isLoading">Save</button>
          <button type="button" class="btn btn-light" @click="clear(); isItems2UpdateMode = false;">Cancel</button>
        </div>
      </div>
    </div>

    <!-- Your unique URL -->
    <div class="col-12 col-md-3" v-if="isClubhouseUser">
      <div class="border border-secondary-subtle mb-4 p-3 rounded text-break" v-if="data?.clubDetailUrl">
        <h5 class="mb-4">Your unique URL</h5>
        <a :href="data?.clubDetailUrl" target="_blank">{{ data.clubDetailUrl }}</a>
        <div class="mt-3 d-flex justify-content-end">
          <CopyButton label="Copy Link" :textToCopy="data.clubDetailUrl" class="btn-sm" />
        </div>
      </div>
      <div class="border border-secondary-subtle p-3 rounded" v-if="settings.showShopInParticipationDashboard">
        <h5 class="mb-4">Shop</h5>
        <p>You can order anything you need to run your {{terms?.ProgramPlural.toLowerCase()}} from our store</p>
        <div class="mt-3 d-flex justify-content-end">
          <a :href="shopLink" target="_blank" class="btn btn-sm btn-primary">Shop here</a>
        </div>
      </div>
    </div>

    <!-- Shop Link -->
    <div class="col-12 col-md-3" v-if="isNationalAssociationUser && settings.showShopInParticipationDashboard">
      <div class="border border-secondary-subtle p-3 rounded">
        <h5 class="mb-4">Shop Link</h5>
        <input type="text" v-model="shopLink" class="form-control" />
        <div class="mt-3 d-flex justify-content-end">
          <button type="button" class="btn btn-sm btn-primary" @click="saveShopLink" :disabled="isLoading">{{ shopeLinkUpdated ?
            'Updated!' : 'Update Link' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth-store';
import { useDashboardStore } from '@/stores/dashboard-store';
import { type IDashboardItem, type IDashboardData } from '@/types';
import { storeToRefs } from 'pinia';
import { onMounted, ref, nextTick } from 'vue';
// CKEditor removed - replaced with TipTap RichTextEditor component
import RichTextEditor from '@/components/common/RichTextEditor.vue';
import CopyButton from '@/components/common/CopyButton.vue';
import { useSettingStore } from "@/stores/setting-store";
import { useTermsStore } from "@/stores/language-terms";
const { terms } = storeToRefs(useTermsStore());

// TipTap handled internally by RichTextEditor component

const { displayName, isClubhouseUser, isNationalAssociationUser } = storeToRefs(useAuthStore());
const { data } = storeToRefs(useDashboardStore());
const { isLoading } = storeToRefs(useDashboardStore());
const { updateDashboardData, loadDashboardData } = useDashboardStore();
const { getSetting } = useSettingStore();
const introduction = ref();
const introduction2 = ref();
const isEditIntro = ref(false);
const isEditIntro2 = ref(false);
const items = ref<IDashboardItem[]>([]);
const items2 = ref<IDashboardItem[]>([]);
const itemIndex = ref<number | undefined>(undefined);
const isDeleteItemMode = ref<boolean>(false);
const isDeleteItems2Mode = ref<boolean>(false);
const titleElement = ref();
const title2Element = ref();
const title = ref('');
const body = ref('');
const title2 = ref('');
const body2 = ref('');
const shopLink = ref('');
const shopeLinkUpdated = ref(false);
const isUpdateMode = ref(false);
const isItems2UpdateMode = ref(false);
const showShop = ref(false);
// Refs to scroll to editors
const itemFormRef = ref<HTMLElement | null>(null);
const item2FormRef = ref<HTMLElement | null>(null);

const { setting } = storeToRefs(useSettingStore());
const settings = ref(setting);

const scrollTo = (el: HTMLElement | null) => {
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const setForm = (item: IDashboardItem, index: number) => {
  itemIndex.value = index;
  title.value = item.title;
  body.value = item.body;
  isUpdateMode.value = true;
  focusOnTitle();
  nextTick(() => scrollTo(itemFormRef.value));
}

const setItems2Form = (item: IDashboardItem, index: number) => {
  itemIndex.value = index;
  title2.value = item.title;
  body2.value = item.body;
  isItems2UpdateMode.value = true;
  focusOnTitle();
  nextTick(() => scrollTo(item2FormRef.value));
}

const focusOnTitle = () => {
  nextTick(() => {
    titleElement.value.focus();
  })
}

const focusOnTitle2 = () => {
  nextTick(() => {
    title2Element.value.focus();
  })
}

const addItem = () => {
  isUpdateMode.value = true;
  focusOnTitle();
  nextTick(() => scrollTo(itemFormRef.value));
}

const addItems2 = () => {
  isItems2UpdateMode.value = true;
  focusOnTitle2();
  nextTick(() => scrollTo(item2FormRef.value));
}

const saveItem = async () => {
  if (title.value && body.value) {
    if (itemIndex.value != undefined && itemIndex.value >= 0) {
      items.value[itemIndex.value].title = title.value;
      items.value[itemIndex.value].body = body.value;
    } else {
      items.value.push({ title: title.value, body: body.value });
    }
    
    await saveDashboardData();
    clear();
  }
}

const saveItems2 = async () => {
  if (title2.value && body2.value) {
    if (itemIndex.value != undefined && itemIndex.value >= 1000) {
      items2.value[itemIndex.value - 1000].title = title2.value;
      items2.value[itemIndex.value - 1000].body = body2.value;
    } else {
      items2.value.push({ title: title2.value, body: body2.value });
    }

    await saveDashboardData();
    clear2();
  }
}

const deleteItem = async (index: number) => {
  items.value.splice(index, 1);
  clear();
  await saveDashboardData();
}

const deleteItems2 = async (index: number) => {
  items2.value.splice(index - 1000, 1);
  clear2();
  await saveDashboardData();
}

const saveIntroduction = async () => {
  await saveDashboardData();
  isEditIntro.value = false;
}

const saveContent = async () => {
  await saveDashboardData();
  isEditIntro2.value = false;
}

const cancelIntroduction = async () => {
  await refreshData();
}

const saveShopLink = async () => {
  await saveDashboardData();
  shopeLinkUpdated.value = true;
  setTimeout(() => {
    shopeLinkUpdated.value = false;
  }, 1500);
}

const mapDashboardData = (newData) => {
  introduction.value = newData.introduction ?? '';
  items.value = newData.items ?? [];
  shopLink.value = newData.shopLink ?? '';
  introduction2.value = newData.introduction2 ?? '';
  items2.value = newData.items2 ?? [];
  isEditIntro.value = false;
  isEditIntro2.value = false;
}

const saveDashboardData = async () => {
  await updateDashboardData({
    introduction: introduction.value,
    items: items.value,
    shopLink: shopLink.value,
    introduction2: introduction2.value,
    items2: items2.value
  } as IDashboardData);

  mapDashboardData(data.value);
}

const clear = () => {
  if (itemIndex.value != undefined) {
    isUpdateMode.value = false;
  } else {
    focusOnTitle();
  }
  isDeleteItemMode.value = false;
  itemIndex.value = undefined;
  title.value = '';
  body.value = '';
}

const clear2 = () => {
  if (itemIndex.value != undefined) {
    isItems2UpdateMode.value = false;
  } else {
    focusOnTitle2();
  }
  isDeleteItems2Mode.value = false;
  itemIndex.value = undefined;
  title2.value = '';
  body2.value = '';
}

onMounted(async () => {
  await getSetting();
  await refreshData();
});

const refreshData = async () => {
  await loadDashboardData();
  if (data.value) {
    mapDashboardData(data.value);
  }
}

</script>

<style scoped>
.dashboard {
  max-width: 1440px;
}
</style>

<style>
.ck-editor__editable {
  min-height: 200px;
}
</style>

<style>
figure img {
  position: relative;
  max-width: 100%;
  height: revert;
}
</style>